import client from "./client";

export const fetchAlbums = async () =>{
    const response = await client.get("albums/?per_page=100")
    return response.data;

};